import React, { useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { useLanguage } from '../context/LanguageContext';
import './About.css';

function About() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const content = contentRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        if (content) animate(content, { opacity: [0, 1], y: [20, 0], duration: 600, ease: 'outExpo' });
        observer.disconnect();
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="about">
      <div className="about-header">
        <h2 id="quienes-somos-title" className="about-title">{t('about.title')}</h2>
        <p className="about-tagline">{t('about.tagline')}</p>
      </div>
      <div ref={contentRef} className="about-body">
        <p className="about-lead">{t('about.p1')}</p>
        <p className="about-text">{t('about.p2')}</p>
        <p className="about-text">{t('about.p3')}</p>
      </div>
    </div>
  );
}

export default About;
